import A_sign from "./A.svg"
import B_sign from "./B.svg"
import C_sign from "./C.svg"
import D_sign from "./D.svg"
import E_sign from "./E.svg"
import F_sign from "./F.svg"
import G_sign from "./G.svg"
import H_sign from "./H.svg"
import I_sign from "./I.svg"
import J_sign from "./J.svg"
import K_sign from "./K.svg"
import L_sign from "./L.svg"
import M_sign from "./M.svg"
import N_sign from "./N.svg"
import O_sign from "./O.svg"
import P_sign from "./P.svg"
import Q_sign from "./Q.svg"
import R_sign from "./R.svg"
import S_sign from "./S.svg"
import T_sign from "./T.svg"
import U_sign from "./U.svg"
import V_sign from "./V.svg"
import W_sign from "./W.svg"
import X_sign from "./X.svg"
import Y_sign from "./Y.svg"
import Z_sign from "./Z.svg"

import A_hand from "./Ahand.svg"
import B_hand from "./Bhand.svg"
import C_hand from "./Chand.svg"
import D_hand from "./Dhand.svg"
import E_hand from "./Ehand.svg"
import F_hand from "./Fhand.svg"
import G_hand from "./Ghand.svg"
import H_hand from "./Hhand.svg"
import I_hand from "./Ihand.svg"
import J_hand from "./Jhand.svg"
import K_hand from "./Khand.svg"
import L_hand from "./Lhand.svg"
import M_hand from "./Mhand.svg"
import N_hand from "./Nhand.svg"
import O_hand from "./Ohand.svg"
import P_hand from "./Phand.svg"
import Q_hand from "./Qhand.svg"
import R_hand from "./Rhand.svg"
import S_hand from "./Shand.svg"
import T_hand from "./Thand.svg"
import U_hand from "./Uhand.svg"
import V_hand from "./Vhand.svg"
import W_hand from "./Whand.svg"
import X_hand from "./Xhand.svg"
import Y_hand from "./Yhand.svg"
import Z_hand from "./Zhand.svg"

export const Signimage = {
  A: A_sign,
  B: B_sign,
  C: C_sign,
  D: D_sign,
  E: E_sign,
  F: F_sign,
  G: G_sign,
  H: H_sign,
  I: I_sign,
  J: J_sign,
  K: K_sign,
  L: L_sign,
  M: M_sign,
  N: N_sign,
  O: O_sign,
  P: P_sign,
  Q: Q_sign,
  R: R_sign,
  S: S_sign,
  T: T_sign,
  U: U_sign,
  V: V_sign,
  W: W_sign,
  X: X_sign,
  Y: Y_sign,
  Z: Z_sign,
}

export const Signpass = [
  {
    src: A_hand,
    alt: "A",
  },
  {
    src: B_hand,
    alt: "B",
  },
  {
    src: C_hand,
    alt: "C",
  },
  {
    src: D_hand,
    alt: "D",
  },
  {
    src: E_hand,
    alt: "E",
  },
  {
    src: F_hand,
    alt: "F",
  },
  {
    src: G_hand,
    alt: "G",
  },
  {
    src: H_hand,
    alt: "H",
  },
  {
    src: I_hand,
    alt: "I",
  },
  {
    src: J_hand,
    alt: "J",
  },
  {
    src: K_hand,
    alt: "K",
  },
  {
    src: L_hand,
    alt: "L",
  },
  {
    src: M_hand,
    alt: "M",
  },
  {
    src: N_hand,
    alt: "N",
  },
  {
    src: O_hand,
    alt: "O",
  },
  {
    src: P_hand,
    alt: "P",
  },
  {
    src: Q_hand,
    alt: "Q",
  },
  {
    src: R_hand,
    alt: "R",
  },
  {
    src: S_hand,
    alt: "S",
  },
  {
    src: T_hand,
    alt: "T",
  },
  {
    src: U_hand,
    alt: "U",
  },
  {
    src: V_hand,
    alt: "V",
  },
  {
    src: W_hand,
    alt: "W",
  },
  {
    src: X_hand,
    alt: "X",
  },
  {
    src: Y_hand,
    alt: "Y",
  },
  {
    src: Z_hand,
    alt: "Z",
  },
]
